export default __webpack_public_path__ + "static/media/serkan-sepil.270d4d0f.png";